export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új védőoltás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "vaccine",
                label: "Oltóanyag",
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "occupationalIndication",
                label: "Foglalkozási Indikáció",
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "dosage",
                label: "Adagolás",
                formType: "text",
                formSize: 2,
                formVisible: true,
                visibility: false
            },
            {
                name: "basicImmunization",
                label: "Alapimmunizálás",
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "boosterVaccination",
                label: "Emlékeztető oltás",
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "expirationMonth",
                label: "Lejárati idő (hónap)",
                formRequired: true,
                formType: "number",
                formSize: 2,
                formVisible: true
            },
            {
                name: "vaccinationNumber",
                label: "Oltóanyag száma",
                visibility: false,
                formSize: 2,
                formVisible: true
            },
            {
                name: "contraindications",
                label: "Kontraindikáció",
                formType: "textarea",
                formSize: 12,
                formVisible: true,
                visibility: false
            },
            {
                name: "description",
                label: "Leírás",
                visibility: false,
                formSize: 3,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "deleted",
                label: "deleted",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
